import styled from 'styled-components';
import { layout, space, border, flexbox, color } from 'styled-system';
import { outlined, contained, text } from './ButtonVariants';

export const Button = styled.button`
  font-weight: 600;
  font-size: 14px;
  padding: ${props => (props.padding ? props.padding : '10px 24px')};
  border-radius: 8px;
  line-height: 18px;
  letter-spacing: 0.2px;
  font-family: 'Montserrat', sans-serif;
  box-shadow: none;
  margin: 0;
  height: 48px;

  ${border};
  ${space};
  ${layout};
  ${flexbox};
  ${color};
  ${props => props.mode === 'outline' && outlined};
  ${props => props.mode === 'contained' && contained};
  ${props => props.mode === 'text' && text};
`;
